import React, {useState, useEffect} from 'react'
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom"
import { AuthProvider } from './contexts/AuthContext';

import MainMenu from './Site/MainMenu/MainMenu'

import styles from './App.module.scss'
import utilityPages from "./Site/utilityPages"
import sitePages from "./Site/sitePages"
import homePages from "./Site/homePages";

import Footer from "./Site/Footer/Footer";
import MessageModal from "./UI/Modals/Message/MessageModal";
import Pages from "./Components/Pages/Pages";
import Utilities from "./Components/Utilities/Utilities";
import Welcome from "./Components/Welcome";
import Login from "./Components/Login";
import Register from "./Components/Register";
import Backdrop from "./UI/Modals/Backdrop";
import Dashboard from './Components/Authenticated/Dashboard/Dashboard';
import ProtectedRoute from './Components/ProtectedRoute';
import Admin from './Components/Authenticated/Admin/Admin';
import Games from "./Components/Games/Games";


export default function App() {

    const [selectedPages, setSelectedPages] = useState(utilityPages)
    const [location, setLocation] = useState('pages')
    const [isFullWidth, setIsFullWidth] = useState(false)
    // const [token, setToken] = useState();

    // Suppress noisy browser ResizeObserver loop warnings in dev
    useEffect(() => {
        const matches = (text) => (
            text.includes('ResizeObserver loop completed with undelivered notifications') ||
            text.includes('ResizeObserver loop limit exceeded')
        );
        const shouldSuppress = (arg) => {
            if (!arg) return false;
            if (typeof arg === 'string') return matches(arg);
            const msg = (arg && ((arg.message || arg.toString) && arg.toString())) || '';
            return typeof msg === 'string' && matches(msg);
        };

        const originalError = console.error;
        const originalWarn = console.warn;

        console.error = (...args) => {
            if (shouldSuppress(args[0])) return;
            originalError.apply(console, args);
        };

        console.warn = (...args) => {
            if (shouldSuppress(args[0])) return;
            originalWarn.apply(console, args);
        };

        const errorListener = (event) => {
            if (shouldSuppress(event?.error) || shouldSuppress(event?.message)) {
                // Best-effort to prevent dev overlays from showing this benign warning
                if (typeof event.preventDefault === 'function') event.preventDefault();
                if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
                return false;
            }
            return undefined;
        };

        window.addEventListener('error', errorListener);

        return () => {
            console.error = originalError;
            console.warn = originalWarn;
            window.removeEventListener('error', errorListener);
        };
    }, []);

    const setSelectedPagesHandler = (location) => {
        setLocation(location)
        switch (location) {
            case 'home':
                return setSelectedPages(homePages)
            case 'pages':
                return setSelectedPages(sitePages)
            case 'utilities':
                return setSelectedPages(utilityPages)
            default:
                setSelectedPages(sitePages)
        }

    }

    function generateRoutes(pages) {
        return pages.flatMap((page, index) => {
            const {to, component: Component, children} = page
            // Nested pages
            if (children?.length) {
                return generateRoutes(children)
            }
            return <Route key={index} path={to} element={<Component/>}/>
        })
    }


    return (
        <AuthProvider>
            <BrowserRouter>
                <Backdrop/>
                <MessageModal/>
                <div className={`${styles.main} ${isFullWidth ? styles.fullWidth : ''}`}>
                    <MainMenu selectPages={setSelectedPagesHandler} location={location}
                              pages={selectedPages}
                              isFullWidth={isFullWidth}
                              onToggleFullWidth={() => setIsFullWidth(prev => !prev)}/>
                    <div className={styles.content}>
                        <Routes>
                            {generateRoutes(selectedPages)}
                            <Route path={'/'} element={<Welcome selectPages={setSelectedPagesHandler}/>}/>
                            <Route path={'/utilities'} element={<Utilities/>}/>
                            <Route path={'/games'} element={<Games/>}/>
                            <Route path={'/pages'} element={<Pages/>}/>
                            <Route path={'/login'} element={<Login/>}/>
                            <Route path={'/register'} element={<Register/>}/>
                            <Route path={'/dashboard'} element={<ProtectedRoute><Dashboard/></ProtectedRoute>}/>
                            <Route path={'/admin'} element={<ProtectedRoute><Admin/></ProtectedRoute>}/>
                            <Route path={'/markdown-editor'} element={<Navigate to={'/editor'} replace/>}/>
                            <Route path={'/json-editor'} element={<Navigate to={'/editor'} replace/>}/>
                            <Route path={'/yaml-editor'} element={<Navigate to={'/editor'} replace/>}/>
                            <Route path={'*'} element={<Navigate to={'/'} replace/>}/>
                        </Routes>
                    </div>
                    <Footer/>
                </div>
            </BrowserRouter>
        </AuthProvider>
    )
}
